// Description: This file contains the order constants.

export const ORDERS_GRID_HEADER_NAME_TOKENS = {
    orderNumber: 'order.column.number',
    version: 'order.column.version',
    name: 'order.column.name'
};

export enum ORDER_STATUS {
    approved = 'Approved',
    draft = 'Draft',
    pending = 'Approval Pending',
    cancelled = 'Cancelled',
    notOrdered = 'Not Ordered',
    quote = 'Quote',
    rejected = 'Rejected',
    revised = 'Revised',
    quoted = 'Quoted',
    multiple = 'Multiple'
}

export enum ORDER_STATE {
    order = 'Order',
    quote = 'Quote',
    deal = 'Deal'
}

export enum ORDER_ROLES {
    approver = 'Approver',
    signer = 'Signer',
    carbonCopy = 'CarbonCopy'
}

export const ORDER_STATUS_COLOR = {
    Approved: 'success',
    'Approval Pending': 'warning',
    Draft: 'default',
    Cancelled: 'secondary'
};

export const ORDER_COLUMN_NAMES = {
    orderNumber: 'orderNumber'
};
